<template>
  <div :class="classes">
     <pt-page-title title="链接管理" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
          <el-button slot="before-left" type="primary" @click="createdLink">新建链接</el-button>
      </pt-page-title>
        <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter @Filter="Filter" ref="filter">
          <template>
            <el-button type="primary" @click="Filter()">筛选</el-button>
            <!-- <el-button type="primary">导出</el-button> -->
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
        </pt-page-factor-filter>
      <pt-link-manage-table ref="table" :tableLabels="tableLabels" :paramsData="paramsData">
        <el-table-column label="操作">
          <template slot-scope="scope">
          <el-button type="text"  v-clipboard:copy="copyLink(scope.row)"  v-clipboard:success="onCopy" v-clipboard:error="onError">复制连接</el-button>
          <el-button type="text" @click="deleteLink(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </pt-link-manage-table>
  </div>
</template>

<script>
// 组件class前缀
import ptLinkManageTable from './pt-link-manage-table/withData'
import { tableLabels, filterLabels } from './link'
import { emptyObject } from '@/utils/lifebankUtils'
const prefixCls = 'pt-link-manage'
export default {
  name: 'pt-link-manage',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    table () {
      return this.$refs.table
    }
  },
  data () {
    return {
      tableLabels: tableLabels,
      filterLabels: filterLabels,
      isFromRouter: false,
      params: {},
      paramsData: {},
      searchKey: null
    }
  },
  components: {
    ptLinkManageTable
  },
  methods: {
    copyLink (row) {
      return row.trackUrl
    },
    emptySearch () {
      this.$delete(this.paramsData, 'keyword')
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      this.$set(this.paramsData, 'keyword', val)
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      this.paramsData = { ...this.params }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.params)
      }
    },
    cleanParams () {
      emptyObject(this.params)
      emptyObject(this.paramsData)
    },
    deleteLink (row) {
      this.$confirm('您确定删除该链接吗？', '删除链接', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(_ => {
        this.$emit('deleteLink', row.id)
      })
    },
    onCopy () {
      this.$message.success('复制成功，请前往您需要的位置粘贴')
    },
    onError () {
      this.$message.error('复制失败')
    },
    createdLink () {
      this.$router.push('/link-form/0/false')
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
